import { FC, ReactElement } from "react"
import { ReactElementExtended } from "./ReportGenerator"

export type DimensionSpan = `${number}%`

export interface IContentWrapperProps {
	children: ReactElement<ReactElementExtended>
	idKey: string
	rowSpan: DimensionSpan
	colSpan: DimensionSpan
	pageBreakpoints?: number[]
}

export const findSpanOutOf60 = (
	spanPercentage: DimensionSpan,
	{ clampToPage = false }: { clampToPage?: boolean } = {}
) => {
	const parsedPercentage = Number.parseFloat(spanPercentage.replace("%", ""))
	if (Number.isFinite(parsedPercentage) === false) {
		return 60
	}

	const units = Math.max(1, Math.round((parsedPercentage / 100) * 60))
	return clampToPage === true ? Math.min(60, units) : units
}
export const ContentWrapper: FC<IContentWrapperProps> = (props) => {
	const rowSpanOutOf60 = findSpanOutOf60(props.rowSpan)
	const colSpanOutOf60 = findSpanOutOf60(props.colSpan, { clampToPage: true })
	return (
		<div
			className={`gap-10 overflow-hidden`}
			key={props.idKey}
			style={{
				gridColumn: `span ${colSpanOutOf60} / span ${colSpanOutOf60}`,
				gridRow: `span ${rowSpanOutOf60} / span ${rowSpanOutOf60}`,
			}}
		>
			{props.children}
		</div>
	)
}
